import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@strava/ui/Avatar';
import Stat from '@strava/ui/Stat';
import Stats from '@strava/ui/Stats';

import I18n from 'utils/I18n';
import Analytics from 'utils/analytics';

import styles from './styles.scss';

const Details = ({
  athlete: {
    name,
    location,
    avatarUrl,
    followersCount,
    followingCount,
    followUrl
  }
}) => (
  <div className={styles.details}>
    <div className={styles.athlete}>
      <Avatar name={name} src={avatarUrl} size="xlarge" type="athlete" />
      <h2 className={styles.name} id="name">
        {name}
      </h2>
      <div className={styles.location}>{location}</div>
      <a
        className={`${styles.followButton} btn btn-primary`}
        href={followUrl}
        onClick={() =>
          Analytics.trackV2({
            category: 'athletes',
            page: 'athlete_profile',
            action: 'click',
            element: 'follow_athlete_button'
          })
        }
      >
        {I18n.t('strava.athletes.show_public.follow_cta')}
      </a>
    </div>

    <Stats listClassName={styles.followStats}>
      <Stat
        value={followersCount}
        label={I18n.t('strava.athletes.show_public.followers')}
        type="stat-xl"
        wrapperClassName={styles.stat}
        labelClassName={styles.statLabel}
      />
      <Stat
        value={followingCount}
        label={I18n.t('strava.athletes.show_public.following')}
        type="stat-xl"
        wrapperClassName={styles.stat}
        labelClassName={styles.statLabel}
      />
    </Stats>
  </div>
);

Details.propTypes = {
  athlete: PropTypes.shape({
    name: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string.isRequired,
    primarySport: PropTypes.string.isRequired,
    followersCount: PropTypes.number.isRequired,
    followingCount: PropTypes.number.isRequired,
    followUrl: PropTypes.string.isRequired
  }).isRequired
};
export default Details;
